module.exports = __webpack_public_path__ + "static/media/Guillotine.86fe6ebf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/shgn/footerLogos/mobile/Guillotine.svg
// module id = 100
// module chunks = 0